/** Member groups — keep in sync with backend Member.group and admin form. */
export const MEMBER_GROUPS = [
  { key: 'PI', label: 'Principal Investigator' },
  { key: 'Postdoc', label: 'Research Staff' },
  { key: 'PhD', label: 'PhD Students' },
  { key: 'Master', label: "Master's Students" },
  { key: 'Undergraduate', label: 'Undergraduate Students' },
  { key: 'Graduated', label: 'PHD Graduates' },
  { key: 'MasterBsGraduated', label: 'MASTER & BS Graduates' },
  { key: 'Other', label: 'Former Research Staff' },
] as const;

export type MemberGroupKey = (typeof MEMBER_GROUPS)[number]['key'];

export const memberGroupLabelMap: Record<MemberGroupKey, string> =
  Object.fromEntries(MEMBER_GROUPS.map((g) => [g.key, g.label])) as Record<
    MemberGroupKey,
    string
  >;

export const isMemberGroup = (value: string): value is MemberGroupKey =>
  MEMBER_GROUPS.some((g) => g.key === value);

/** Legacy stored value "Alumni" maps to PHD Graduates (Graduated). */
export const normalizeMemberGroup = (group?: string): MemberGroupKey => {
  if (group === 'Alumni') return 'Graduated';
  if (group && isMemberGroup(group)) return group;
  return 'Other';
};

export const memberGroupLabel = (group?: string): string =>
  memberGroupLabelMap[normalizeMemberGroup(group)];

/** Nav / mega-menu links — same order and labels as Members page directory. */
export const MEMBER_GROUP_NAV_LINKS = MEMBER_GROUPS.map((g) => ({
  label: g.label,
  to: `/members?group=${encodeURIComponent(g.key)}`,
}));
